<div class="opciones">
    <div class="col-md-12">
        <p>
            Elija la opción hacia donde quiere ir.
        </p>
    </div>
    <div class="col-md-12">
        <a (click)="abrirIngreso()">

            <button mat-raised-button color="primary">Ingreso BNUP</button>
        </a>
        <!-- <button mat-raised-button color="primary" (click)="sign()">Expedientes en linea</button> -->
    </div>
    <div class="col-md-12" style="padding-top: 10px;">
        <a (click)="abrirSeguimiento()">

            <button md-3 mat-raised-button color="primary">Seguimiento BNUP</button>
        </a>
        <!-- <button mat-raised-button color="primary" (click)="sign()">Expedientes en linea</button> -->
    </div>


    <!-- <div *ngIf="nombreMuni!='Prueba Solnet'" class="col-md-12" style="padding-top: 10px;">
        <button mat-raised-button color="primary" (click)="seguimiento()">Seguimiento de Certificados</button>
    </div>-->
</div>